/**
 * @param {{ data?: Record<string, unknown>, id?: string } | null | undefined} option
 * @returns {string}
 */
export function breweryPortalAutocompleteLabel(option) {
  if (!option || !option.data) {
    return '';
  }
  const dataRecord = option.data;
  const name =
    typeof dataRecord.name === 'string' ? dataRecord.name.trim() : '';
  const city = typeof dataRecord.city === 'string' ? dataRecord.city.trim() : '';
  const stateAbbrev = typeof dataRecord.state === 'string' ? dataRecord.state.trim() : '';
  const locationPart =
    city && stateAbbrev ? `${city}, ${stateAbbrev}` : city || stateAbbrev;
  const idFallback = typeof option.id === 'string' ? option.id : String(option.id || '');
  if (!locationPart) {
    return name.length > 0 ? name : idFallback;
  }
  if (!name) {
    return locationPart;
  }
  return `${name} · ${locationPart}`;
}
